<template>
  <v-footer class="py-4" dark height="auto">
    <v-container mx-auto>
      <v-layout wrap>
        <v-flex xs5>
          <base-btn
            v-for="(item, i) in items"
            :key="i"
            :href="item.href"
            class="ml-0 mr-3"
            color="lime"
            square
            target="_blank"
          >
            <v-icon v-text="item.icon"/>
          </base-btn>
        </v-flex>
        <v-spacer/>
        <v-flex xs4>
          <h3>&reg;Asfarma International Pharma Marketing</h3>
        </v-flex>
        <base-btn class="mr-0" square title="Go to top" @click="$vuetify.goTo(0)">
          <v-icon>mdi-chevron-up</v-icon>
        </base-btn>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        href: "https://twitter.com/asfarma",
        icon: "mdi-twitter"
      },
      {
        href: "https://www.instagram.com/asfarma/",
        icon: "mdi-instagram"
      },
      {
        href:
          "https://www.facebook.com/Asfarma-International-Pharma-Marketing-195762987151932",
        icon: "mdi-facebook"
      },
      {
        href:
          "https://www.linkedin.com/company/asfarma-international-pharma-marketing/",
        icon: "mdi-linkedin"
      },
      {
        href: "https://www.youtube.com/channel/UC2YWimQX02P0elmZM59IKMw/videos",
        icon: "mdi-youtube"
      },
      {
        href: "https://tr.pinterest.com/bim0331/",
        icon: "mdi-pinterest"
      }
    ]
  })
};
</script>
